import React from 'react'
import {Button, Card, CardBody, Col, Form, FormGroup, Input, Row} from "reactstrap";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";

let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);

const propTypes = {};

class EditPaymentView extends React.Component {
    handleChange = this.handleChange.bind(this);

    constructor(props) {
        super(props);
        this.state = {
            paymentInfo: props.paymentInfo,
            inputsUpdated: true,
        };
    }

    handleChange(event) {
        let newValue = event.target.value;
        let targetId = event.target.id;
        const updatedPrice = parseFloat(newValue.replace(/,/g, '-.')) * 100;

        switch (targetId) {
            case "input-per-class":
                this.setState(prevState => ({
                    paymentInfo: {
                        ...prevState.paymentInfo,
                        perClass: updatedPrice
                    }
                }));
                break;
            case "input-per-client":
                this.setState(prevState => ({
                    paymentInfo: {
                        ...prevState.paymentInfo,
                        perStudent: updatedPrice
                    }
                }));
                break;
            default:
                return
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (nextProps.paymentInfo !== this.props.paymentInfo) {
            this.setState({
                paymentInfo: nextProps.paymentInfo,
            })
        }
    }

    render() {
        this.localize();

        return (
            <Card className="bg-secondary shadow">
                <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                        <div className="pl-lg-4">
                            <Row>
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-per-class"
                                        >
                                            {resourceStrings.per_class}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={this.handleChange}
                                            defaultValue={((this.state.paymentInfo.perClass || 0) / 100).toFixed(2)}
                                            id="input-per-class"
                                            type="number"
                                            min={0}
                                            pattern="^\d+(?:\.\d{1,2})?$"
                                            placeholder="0.00"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-per-client"
                                        >
                                            {resourceStrings.per_client}
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            onChange={this.handleChange}
                                            defaultValue={((this.state.paymentInfo.perStudent || 0) / 100).toFixed(2)}
                                            id="input-per-client"
                                            type="number"
                                            min={0}
                                            pattern="^\d+(?:\.\d{1,2})?$"
                                            placeholder="0.00"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                        </div>
                        <Row>
                            <Col lg="12">
                                <Col className="text-right">
                                    <Button
                                        color="warning"
                                        outline="button"
                                        size="lg"
                                        onClick={e => this.props.closeEditPaymentView(e)}
                                    >
                                        {commonStrings.close}
                                    </Button>

                                    <Button
                                        color="default"
                                        size="lg"
                                        onClick={e => this.props.updatePaymentInfo(e, this.state.paymentInfo)}
                                    >
                                        {commonStrings.save}
                                    </Button>
                                </Col>
                            </Col>
                        </Row>

                    </Form>
                </CardBody>
            </Card>
        )
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

}

EditPaymentView.propTypes = propTypes;

export default EditPaymentView;